/* projects/shared/layouts/responsive-nav-bar/shared-sidebar-item/shared-sidebar-item.scss */
shared-sidebar-item .shared-sidebar-item .sidebar-item-beta-flag,
:host .shared-sidebar-item .sidebar-item-beta-flag {
  border-radius: 4px;
  background-color: var(--color-blue);
  color: var(--color-white);
  font-size: var(--font-xxs);
  line-height: 24px;
  text-transform: uppercase;
  padding: 0 2px;
  text-align: center;
}
shared-sidebar-item,
:host {
  display: flex;
  align-self: center;
  height: var(--sidebar-item-height);
  width: var(--sidebar-item-width);
  color: var(--color-grey-dark-7);
  font-size: var(--font-s);
}
shared-sidebar-item.last-child .shared-sidebar-item,
:host.last-child .shared-sidebar-item {
  border-bottom: none;
}
shared-sidebar-item .shared-sidebar-item,
:host .shared-sidebar-item {
  display: flex;
  flex-grow: 1;
  align-items: center;
  font: inherit;
  height: fit-content;
  width: 100%;
  color: inherit;
  border: none;
  background-color: inherit;
  border-radius: var(--standard-layout-border-radius);
  text-align: left;
  cursor: pointer;
}
shared-sidebar-item .shared-sidebar-item.left-icon-layout,
:host .shared-sidebar-item.left-icon-layout {
  display: grid;
  grid-template-columns: var(--space-xl) 1fr auto;
}
shared-sidebar-item .shared-sidebar-item:hover,
shared-sidebar-item .shared-sidebar-item:focus,
:host .shared-sidebar-item:hover,
:host .shared-sidebar-item:focus {
  color: var(--color-blue-text-with-non-white-background);
  background-color: var(--sidebar-selected-color);
  border-radius: var(--space-s);
  outline-color: var(--color-blue);
}
shared-sidebar-item .shared-sidebar-item:hover:not(:focus-visible),
shared-sidebar-item .shared-sidebar-item:focus:not(:focus-visible),
:host .shared-sidebar-item:hover:not(:focus-visible),
:host .shared-sidebar-item:focus:not(:focus-visible) {
  outline: none;
}
shared-sidebar-item .shared-sidebar-item.selected,
:host .shared-sidebar-item.selected {
  color: var(--color-blue-text-with-non-white-background);
  font-weight: var(--font-weight-bold);
  background-color: var(--sidebar-selected-color);
}
shared-sidebar-item .shared-sidebar-item.disabled,
:host .shared-sidebar-item.disabled {
  pointer-events: none;
}
shared-sidebar-item .shared-sidebar-item.disabled > *,
:host .shared-sidebar-item.disabled > * {
  opacity: 0.5;
}
shared-sidebar-item .shared-sidebar-item.child,
:host .shared-sidebar-item.child {
  background-color: var(--sidebar-selected-color);
  font-size: var(--font-xxs);
}
shared-sidebar-item .shared-sidebar-item.disabled:active,
:host .shared-sidebar-item.disabled:active {
  pointer-events: none;
}
shared-sidebar-item .shared-sidebar-item .sidebar-item-label,
:host .shared-sidebar-item .sidebar-item-label {
  flex-grow: 1;
  padding-left: var(--space-s);
}
shared-sidebar-item .shared-sidebar-item .sidebar-item-beta-flag,
:host .shared-sidebar-item .sidebar-item-beta-flag {
  display: flex;
  padding: var(--space-xs) var(--space-s);
  justify-content: center;
  align-items: center;
  font-size: var(--font-xxxs);
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: normal;
}
shared-sidebar-item .shared-sidebar-item .sidebar-item-icon,
:host .shared-sidebar-item .sidebar-item-icon {
  padding-left: 8px;
}
shared-sidebar-item .shared-sidebar-item .sidebar-item-pill,
:host .shared-sidebar-item .sidebar-item-pill {
  padding: 0;
  font-size: var(--font-xxs);
  line-height: var(--space-m);
  height: var(--space-m);
  min-width: var(--space-l);
}
/*# sourceMappingURL=shared-sidebar-item-EOHEGXRJ.css.map */
